/* eslint-disable prettier/prettier */
import { BoxStyleProps } from "@twilio-paste/core/box";
import { TextStyleProps } from "@twilio-paste/core/text";

export const containerStyles: BoxStyleProps = {
    padding: "space60",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    backgroundColor: "colorBackgroundOffline",
    textAlign: "center"
};

export const titleStyles: TextStyleProps = {
    fontSize: "fontSize30",
    fontFamily: "fontFamilyText",
    fontWeight: "fontWeightBold"
};

// eslint-disable-next-line import/no-unused-modules
export const textStyles: TextStyleProps = {
    marginBottom: "space50",
    marginTop: "space50"
};

// eslint-disable-next-line import/no-unused-modules
export const buttonOkStyles: BoxStyleProps = {
    marginX: "auto",
    backgroundColor: "colorBackgroundPrimary",
    color: "colorTextLink",
    paddingY: "space30",
    paddingX: "space10",
    fontSize: "fontSize30",
    borderColor: "colorBorderPrimary",
    boxShadow: "none",
    borderRadius: "borderRadius20",
    _hover: {
        backgroundColor: "colorBackgroundPrimaryWeak",
        borderColor: "colorBorderPrimaryWeak",
        boxShadow: "none"
    }
};

export const buttonNotOkStyles: BoxStyleProps = {
    marginX: "auto",
    backgroundColor: "colorBackgroundPrimaryWeak",
    color: "colorTextLink",
    paddingY: "space30",
    paddingX: "space10",
    fontSize: "fontSize30",
    borderColor: "colorBorderPrimaryWeak",
    boxShadow: "none",
    borderRadius: "borderRadius20",
    _hover: {
        backgroundColor: "colorBackgroundPrimary",
        borderColor: "colorBorderPrimary",
        boxShadow: "none"
    }
};

export const boxButtons: BoxStyleProps = {
    display: "flex",
    width:"100%",
    padding: "space40",
    alignItems: "center",
    justifyContent: "space-evenly",
    flexDirection: "row"
}
